'use client';
import { MouseEvent } from 'react';
import { FooterLanguages } from 'components/pcc-components';
import {
  useParams,
  usePathname,
  useSearchParams,
  useRouter,
} from 'next/navigation';
import { preventDefaultLinkEvent } from '@cat-ecom/common/utils/DOMUtils';
import { Language as PCCLanguage } from '@cat-ecom/pcc-components/src/components/footer/footer-languages/FooterLanguages';
import { useHash } from 'hooks/use-url-hash';

export const LanguageClientLinks = ({
  langId,
  languages,
}: {
  languages: PCCLanguage[] | Language[];
  langId: string;
}) => {
  const { lang }: esiteParams = useParams();
  const pathname = usePathname();
  const search = useSearchParams().toString();
  const router = useRouter();
  const hash = useHash();

  const hashString = hash ? `#${hash}` : '';
  const searchString = search ? `?${search}` : '';
  const languageHref = ({ seoToken }) =>
    `${pathname.replace(lang, seoToken)}${searchString}${hashString}`;

  const languageLinksMap = languages.map((language) => ({
    ...language,
    localeName: language.locale,
    nativeDescriptionString: language.nativeDescription,
    href: languageHref(language),
  }));

  const onClickHandler = (event: MouseEvent, language: PCCLanguage) => {
    if (preventDefaultLinkEvent(event)) {
      router.push(language.href);
    }
  };

  return (
    <FooterLanguages
      langId={langId}
      languages={languageLinksMap}
      onClick={onClickHandler}
    />
  );
};
